import {Injectable, OnInit} from '@angular/core';
import {Router, CanActivate, NavigationExtras} from '@angular/router';
import {Token} from '../models/token';
import {AuthControllerService} from '../services/auth-controller/auth-controller.service';
import {PageLayoutWidget} from '../components/widgets/page-layout/page-layout.component';
import { map } from "rxjs/operators";
import { AccessTokenResponse } from '../models/accessTokenResponse';

@Injectable()
export class AuthGuard implements CanActivate, OnInit {
    static expiredTokenRefreshTimer;

    constructor(private router: Router,
                private authService: AuthControllerService) {
    }

    ngOnInit() {
		this.canActivate = this.canActivate.bind(this);
        this.authService.subscribeForTokenChange(this.canActivate);
	}

	ngOnDestroy(): void {
		this.authService.unsubscribe(this.canActivate);
	}


    canActivate() {
        const authService = this.authService;
        const searchParameters = this.authService.getSearchParameters();
        const error = searchParameters.error;

        if (error) {
            return this.router.navigate(['/login'], {queryParams: {error: error}});
        }

        const token = searchParameters.token;
        if (token && authService.isValid(token)) {
            authService.saveAuthToken(token);
        }

        if (!AuthGuard.expiredTokenRefreshTimer) {
            AuthGuard.expiredTokenRefreshTimer = setInterval(() => {
                if (this.authService.isAnyTokenPresent() && authService.savedTokenIsAboutToExpireIn5Minutes()) {
                    this.refreshToken(this.authService)
                }
            }, 1000);
        }

        const authenticationCode = searchParameters.code;
        if (!authService.isAnyTokenPresent() && authenticationCode) {
            return this.authService.login(authenticationCode).pipe(map((res) => {
                const token = res.access_token;
                if (authService.isValid(token)) {
                    authService.saveAuthToken(token);
                    authService.saveRefreshToken(res.refresh_token);
                    PageLayoutWidget.messagesFromAuth = PageLayoutWidget.messagesFromAuth.concat(res.messages.map(it => it.message));
                    return true;
                }
                return this.authService.logout();
            }));
        } else if (!authService.isAnyTokenPresent()) {
            return this.authService.logout();
        } else if (authService.savedTokenHasExpired()) {
            return this.refreshToken(authService);
        } else if (authService.isSavedTokenValid()) {
            return authService.pingForValidToken().pipe(map((res) => {
                return true;
            }));
        } else {
            return true;
        }
    }

    private refreshToken(authService) {
        if (authService.savedRefreshToken()) {
            return authService.refreshToken().pipe(map((res: AccessTokenResponse) => {
                const token = res.access_token;
                if (authService.isValid(token)) {
                    authService.saveAuthToken(token);
                    authService.saveRefreshToken(res.refresh_token);
                    return true;
                }
                return this.authService.logout();
            }));
        } else {
            return false;
        }
    }
}


